import Logger from './logger';
import { isSSR } from './helpers';

export const saveItem = (key: string, value: string): void => {
  try {
    window.localStorage.setItem(key, value);
  } catch (err: any) {
    Logger.error(err);
  }
};

export const removeItem = (key: string): void => {
  try {
    window.localStorage.removeItem(key);
  } catch (err: any) {
    Logger.error(err);
  }
};

export const getItem = (key: string): string | null => {
  try {
    if (isSSR) return null;
    const value = window.localStorage.getItem(key);
    return value;
  } catch (err: any) {
    Logger.error(err);
    return null;
  }
};
